
import { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";
import { ProfileEdit } from "./ProfileEdit";

interface ProfileFormData {
  full_name: string;
  location: string;
  phone_number: string;
  job_title: string;
  organization: string;
  company_size: string;
  company_description: string;
  company_industry: string;
  calendly_url: string;
}

interface ProfileFormProps {
  initialData: any;
  showCompanyTab?: boolean;
}

export const ProfileForm = ({ initialData, showCompanyTab = true }: ProfileFormProps) => {
  const { user } = useAuth();
  const { toast } = useToast();
  const [avatarUrl, setAvatarUrl] = useState(initialData?.avatar_url);
  const [cvUrl, setCvUrl] = useState(initialData?.cv_url);

  const onSubmit = async (data: ProfileFormData) => {
    try {
      const updateData = {
        ...data,
        cv_url: cvUrl
      };

      const { error } = await supabase
        .from('profiles')
        .update(updateData)
        .eq('id', user?.id);

      if (error) throw error;

      toast({
        title: "Profile updated successfully",
      });
    } catch (error) {
      toast({
        title: "Error updating profile",
        variant: "destructive",
      });
    }
  };

  return (
    <ProfileEdit
      initialData={initialData}
      avatarUrl={avatarUrl}
      setAvatarUrl={setAvatarUrl}
      cvUrl={cvUrl}
      setCvUrl={setCvUrl}
      onSubmit={onSubmit}
      showCompanyTab={showCompanyTab}
    />
  );
};
